import React, { Component } from "react";

export default class EducationImg extends Component {
  render() {
    return (
      <svg
        width="72"
        height="50"
        viewBox="0 0 72 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M60.4254 14.6962C70.3311 15.5707 -31.988 5.4667 33.3146 28.955C98.6173 52.4433 33.0762 55.9501 33.0762 55.9501"
            stroke="black"
            stroke-width="4"
          />
          <path
            d="M63.3187 10.6654C73.2245 11.5399 -29.0946 1.43591 36.208 24.9242C101.511 48.4126 35.9696 51.9193 35.9696 51.9193"
            stroke="black"
          />
          <path
            d="M63.6372 10.7436C65.9608 11.4004 62.5733 16.4907 61.0883 14.6016"
            stroke="black"
          />
          <path
            d="M36.5 52.0308C39.5 54.5308 33 53.5308 33.5 55.5308"
            stroke="black"
          />
          <path
            d="M62 14.5308C62 15.3592 61.3284 16.5308 60.5 16.5308C59.6716 16.5308 59 15.3592 59 14.5308C59 13.7024 59.6716 13.0308 60.5 13.0308C61.3284 13.0308 62 13.7024 62 14.5308Z"
            fill="black"
          />
          <path
            d="M36 46.0308L4.5 0.530792H13L40.5 34.5308L53.5 0.530792H61L43 46.0308H36Z"
            stroke="black"
            stroke-width="4"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="72" height="58" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}
